module.exports = __webpack_public_path__ + "static/media/arrow_down.af6a0368.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/arrow_down.svg
// module id = 524
// module chunks = 0